// Permission helpers — read menu items from localStorage and expose check functions

export function loadMenuItems() {
  try {
    const raw = localStorage.getItem('menuItems');
    if (!raw) return [];
    return JSON.parse(raw);
  } catch (e) {
    console.warn('Failed to parse menuItems from localStorage', e);
    return [];
  }
}

export function findMenuItemByAction(action) {
  if (!action) return null;
  const items = loadMenuItems();
  // match case-insensitive
  const key = String(action).toLowerCase();
  return items.find(it => String(it.menu_action || it.menu_action_name || '').toLowerCase() === key) || null;
}

export function hasPermission(action, type = 'view') {
  const item = findMenuItemByAction(action);
  if (!item) return false;

  // types: 'view'|'edit'|'delete'
  if (type === 'view') return Number(item.viewaction) === 1;
  if (type === 'edit') return Number(item.editaction) === 1;
  if (type === 'delete') return Number(item.deleteaction) === 1;
  return false;
}

export default {
  loadMenuItems,
  findMenuItemByAction,
  hasPermission,
};
